<h1 class="text-center without-help text-02-m-light text-01-d-light">{{ question.QuestionText }}</h1>
<div class="row radio-select-company">
  <div class="col-xs-12">
    <ng-container *ngFor="let option of question.Options">
      <div class="form-control selector">
        <label class="selector-wrapper" id="lbl_Text">
          <input type="radio" name="radio-demo" [checked]="isOtherHealthInsurance(option.Value)" (click)="selectOtherHealthInsurance(option.Value)" />
          <div class="card-selector shadow-5" id="divSelectIsPreviousInsurer">
            <span data-value="" class="title text-08-d-regular">{{ option.Text }}</span>
          </div>
        </label>
      </div>
    </ng-container>
  </div>
</div>
<button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()">Guardar</button>
